import { useI18n } from '@/locales';

import { BackLink } from './SiteHeader';

/** "Back to property" in the header of checkout and confirmation pages. */
export const BackToPropertyLink = ({ propertyId }: { propertyId?: string }) => {
	const t = useI18n();
	return (
		<BackLink
			href={
				propertyId
					? `/properties/${propertyId}`
					: 'https://travelnest.com'
			}
		>
			{t('Header.backToProperty')}
		</BackLink>
	);
};
